module.exports = __webpack_public_path__ + "media/images/swifticons/thumbs-down-unclicked-8e44ba862c916dee92c2fe940e708b51.svg";